import { render, staticRenderFns } from "./SendNachaToBank.vue?vue&type=template&id=fbd9afee&scoped=true&"
import script from "./SendNachaToBank.vue?vue&type=script&lang=js&"
export * from "./SendNachaToBank.vue?vue&type=script&lang=js&"
import style0 from "./SendNachaToBank.vue?vue&type=style&index=0&id=fbd9afee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9afee",
  null
  
)

component.options.__file = "SendNachaToBank.vue"
export default component.exports